import React from 'react';

import ContentTilesSection from '../../../components/content-tiles-section';
import Head from '../../../../utils/head';
import HeaderSection from '../../explained-term/detail/components/header-section';
import HowItWorks from '../../../components/how-it-works';
import InclusionsExclusions from './components/inclusions-exclusions';
import mapTermsAndConditionsContent from '../../../utils/map-terms-and-conditions-content';
import mapTiles from '../../insurance/utils/combine-content-with-cms-data/map-tiles';
import NoGapProducts from './components/no-gap-dental-products';
import TermsAndConditions from '../../../components/terms-and-conditions';
import TermsSection from '../../../components/sections/terms-section';
import type { NoGapDetailData } from './types';

export type NoGapDetailPageDataProps = {
  noGapDetailData: NoGapDetailData;
};

export type NoGapDetailPageProps = NoGapDetailPageDataProps;

const NoGapDetailPage = ({ noGapDetailData }: NoGapDetailPageProps) => {
  const { excludedServices, howTo, includedServices, identifier, name, summary, termsAndConditions, tiles } =
    noGapDetailData;
  // @ts-expect-error - Automatic, Please fix when editing this file
  const { content } = mapTiles({ cmsSectionContent: tiles });
  // @ts-expect-error - Automatic, Please fix when editing this file
  const { terms } = mapTermsAndConditionsContent({ cmsSectionContent: termsAndConditions });

  return (
    <>
      <Head>
        <title>{name}</title>
        <meta name="description" content={identifier.current ?? undefined} />
      </Head>

      <HeaderSection summary={summary} name={name} slogan={name} />
      <InclusionsExclusions excludedServices={excludedServices} includedServices={includedServices} name={name} />
      <HowItWorks howTo={howTo} />
      <NoGapProducts />
      <ContentTilesSection contentTiles={content} />
      <TermsSection termsComponent={<TermsAndConditions terms={terms} />} />
    </>
  );
};

export default NoGapDetailPage;
